const volumeHandler = (vol: number) => (vol || 100) / 100;
export default volumeHandler;
